import { computed } from 'vue';

import { useI18n } from 'vue-i18n';

import { availableLocalesWithNames, switchLocale } from '@/i18n';

export function useTranslation() {
  const { t, locale } = useI18n();

  const currentLocale = computed({
    get: () => locale.value,
    set: async (newLocale: string) => {
      await switchLocale(newLocale);
    },
  });

  const locales = computed(() => availableLocalesWithNames.value);

  const translate = (key: string, params?: Record<string, unknown>): string => {
    return t(key, params ?? {}) as string;
  };

  const changeLocale = async (newLocale: string): Promise<void> => {
    await switchLocale(newLocale);
  };

  return {
    t: translate,
    locale: currentLocale,
    locales,
    changeLocale,
  };
}
